import { useContext, useEffect, useState } from 'react';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import { ReactComponent as BlueCircleIcon } from '../../assets/images/blue-circle.svg';
import { ReactComponent as EmptyCircleIcon } from '../../assets/images/empty-circle.svg';
import PropTypes from 'prop-types';
import GlobalContext from '../../contexts';
import { find, findIndex } from 'lodash';

import './style.scss';

const StepperComponent = (props) => {
  const [currentActiveStep, setCurrentActiveStep] = useState();
  const [currentSteps, setCurrentSteps] = useState();
  const productId = props.parentId !== 0 ? props.parentId : props.productId;
  const { steppersData } = useContext(GlobalContext);

  useEffect(() => {
    if (steppersData?.length) {
      const steps = steppersData?.filter(
        (x) =>
          x.productId === productId &&
          x.text &&
          x.text !== 'ממתין לתשלום' &&
          x.text !== 'בוטל'
      );
      let activeStep = find(steps, { text: props.status });
      // in case : פסילה במעבדה
      if (activeStep?.id === 79) activeStep = find(steps, { id: 17 });
      activeStep = activeStep?.id;
      setCurrentActiveStep(findIndex(steps, { id: activeStep }));
      setCurrentSteps(steps?.filter((s) => s?.id !== 79));
    }
  }, [steppersData]);

  return (
    <div className="wrapper-stepper">
      <Stepper
        className={`stepper ${!props.isActive && 'not-active'}`}
        activeStep={currentActiveStep}
        alternativeLabel
      >
        {currentSteps?.map((step, index) => (
          <Step className="step" key={index}>
            <StepLabel
              StepIconComponent={
                index <= currentActiveStep ? BlueCircleIcon : EmptyCircleIcon
              }
              classes={{
                root: 'stepperLabelRoot',
                labelContainer: 'stepperLabelContainer',
                iconContainer: `stepperIconContainer ${
                  !props.isActive
                    ? index <= currentActiveStep
                      ? 'stepperDisableFillIconContainer'
                      : 'stepperDisableCircleIconContainer'
                    : ''
                }`,
                label: 'stepperlabel'
              }}
            >
              {step.text}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </div>
  );
};

export default StepperComponent;

StepperComponent.propTypes = {
  productId: PropTypes.number,
  parentId: PropTypes.number,
  status: PropTypes.string,
  isActive: PropTypes.bool
};
